rdefine('app/products/properties/Formular',['backbone','text!products/prop/formular.html'],function(Backbone, template) {
    var arUploadFactory = 0;
    var OptionView = Backbone.Ribs.View.extend({
        tagName:'option',
        bindings:{
            el:{
                text:'model.nameex',
                attr:{
                    value: {
                        data: 'model.id'
                    }
                }
            }
        }
    });
    return Backbone.Ribs.View.extend({
        tagName:'div',
        className:'',
        bindings:{
            /*el:{
                attr:{
                    placeholder:'model.name'
                },
                value:{
                    events:'change keyup',
                    data:'sval.value'
                }
            }*/
            'span':{
                text:'sval.current'
            }
        },
        sval: null,
        initialize:function(options) {

            this.sval = new Backbone.Ribs.Model({});
            this.cform = options.cform;
            var propname = 'property_'+this.model.get("id");
            var cval = this.cform.get(propname) ? JSON.parse(this.cform.get(propname)) : {value:null,name:''};
            var current = cval.value;
            var formulars = _.map(window.Formulars, function(item){
                return {
                    id: item.id,
                    nameex: item.nameex,
                    active: +item.id == +current
                };
            });

            this.sval.set(cval);
            this.sval.on("change", function(){
                this.cform.set(propname, JSON.stringify(this.sval.attributes));
            }.bind(this));
            this.$el.html(Template7.compile(template)({ndx: arUploadFactory++, current:current, formulars: formulars}));
            setTimeout(function() {
                this.$el.find(".select2").selectpicker();
            }.bind(this),0);
            this.$el.find(".select2").on("changed.bs.select",
                function(e, clickedIndex, newValue, oldValue) {
                if(clickedIndex-1 < 0) {
                    this.sval.set('value',"");
                    return;
                }
                this.sval.set("value",formulars[clickedIndex-1].id);
            }.bind(this));
            //this.bindings.el.value.data = 'cform.;
        }
    });
});